import Config from './conf';

export default {

  monthToString: function(monthInt) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul',
        'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return months[monthInt];
  },

  /**
   * Accepts hours (0 to 23) and minutes (0 or 30) and converts it into a 12-hour AM/PM display string.
   */
  toDisplay: function(hours, minutes) {
    let meridian = 'AM';
    if (hours >= 12) {
      meridian = 'PM';
      if (hours > 12) {
        hours -= 12;
      }
    }
    if (minutes === 0) {
      minutes = '00';
    }
    return hours + ':' + minutes + ' ' + meridian;
  },

  /**
   * Converts a string such as "5:30 PM" to hours and minutes (17, 30).
   */
  toHoursMinutes: function(str) {
    const splitted = str.split(' ');
    const meridian = splitted[1];
    const hoursMins = splitted[0].split(':');
    let hours = Number(hoursMins[0]);
    if (meridian === 'PM' && hours !== 12) {
      hours += 12;
    }
    const mins = Number(hoursMins[1]);
    return {
      hours,
      mins
    };
  }
};



// WEBPACK FOOTER //
// ./src/Util.js